module.exports = __webpack_public_path__ + "media/images/wines/tempranillo-crianza/bottle-detail-91ea5eb6ecd04b67d53b91982917a91f.png";